import { FC, ReactNode, useContext } from 'react';
// 方法
import ScrollContext from '../context/scrollContext';

interface EditVirtualTableWrapperProps {
  children?: ReactNode;
}
const EditVirtualTableWrapper: FC<EditVirtualTableWrapperProps> = props => {
  const { children, ...restProps } = props;
  const { renderLen, start, offsetStart } = useContext(ScrollContext);
  let tempNode = null;
  if (Array.isArray(children) && children.length) {
    let contents = children[1];
    if (Array.isArray(contents) && contents.length) {
      const dataSource: any[] = contents
        .slice(start, start + renderLen)
        .map(item => {
          if (Array.isArray(item)) {
            // 兼容antd v4.3.5 --- rc-table 7.8.1及以下
            return item[0];
          } else {
            // 处理antd ^v4.4.0  --- rc-table ^7.8.2
            return item;
          }
        });
      // 要展示的数据
      tempNode = [children[0], dataSource];
    } else {
      tempNode = children;
    }
  }
  return (
    <tbody
      {...restProps}
      style={{ transform: `translateY(-${offsetStart}px)` }}
    >
      {tempNode}
    </tbody>
  );
};

export default EditVirtualTableWrapper;
